import { render } from "./doctor-payment-modal.vue?vue&type=template&id=ee382c9c"
import script from "./doctor-payment-modal.vue?vue&type=script&lang=js"
export * from "./doctor-payment-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__